var map = {
	"./mention-down.svg": "59e0",
	"./not-data.svg": "677e",
	"./not-fount.svg": "4c75",
	"./note-book.svg": "64fb",
	"./note.svg": "8798",
	"./zhuangfa.svg": "69d9"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";